import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../services/api';

export const registerDriverAsync = createAsyncThunk(
  'driver/registerDriver',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post('/drivers', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        'Failed to submit driver registration';
      return rejectWithValue(message);
    }
  }
);

const driverSlice = createSlice({
  name: 'driver',
  initialState: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  reducers: {
    resetDriverStatus: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerDriverAsync.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(registerDriverAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.data = action.payload?.data || action.payload;
      })
      .addCase(registerDriverAsync.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});

export const { resetDriverStatus } = driverSlice.actions;
export default driverSlice.reducer;
